export const create = (base) => ({ base, path: '', query: {} });
/** Construct a URL
 *
 * avoids overwriting any path on the base URL, unlike the built-in URL constructor.
 *
 * Paths and Queries are escaped as part of construction
 */
export const toString = (url) => {
    const _ = new URL(url.base);
    // ensure the slash is handled correctly
    const originalPath = _.pathname === '/' ? '' : _.pathname;
    _.pathname = `${originalPath}${url.path}`;
    Object.entries(url.query).forEach(([key, value]) => {
        _.searchParams.set(key, value);
    });
    return _.href;
};
export const join = (baseUrl, path, query = {}) => ({
    base: baseUrl.base,
    path: baseUrl.path + path,
    query: { ...baseUrl.query, ...query },
});
